import { Content, Header, HeaderLabel, InfoCard, Page } from '@backstage/core-components';
import { AMLCCFormContainer } from './AMLCCFormContainer';

export const AMLCCPage = () => {
  return (
    <Page themeId="home">
      <Header title="Azure Machine Learning Compute Cluster" subtitle="AML CC Request">
        <HeaderLabel label="Owner" value="Orion Infra Team" />
        <HeaderLabel label="Lifecycle" value="Alpha" />
      </Header>
      <Content>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <InfoCard>
            <AMLCCFormContainer
              clusterName=""
              subscription=""
              resourceGroup=""
              amlWorkspace=""
              maxNodes="1"
              vmSKU=""
              clusterAvailability="low_priority"
            />
          </InfoCard>
        </div>
      </Content>
    </Page>
  );
};
